module.exports = __webpack_public_path__ + "static/media/play-button.0f251770.svg";